module.exports = __webpack_public_path__ + "static/media/ErrorIllustration.76d0be07.svg";